export const PLAY_PATTERN_API_FIELD = 'event.attributes.team_possession_origin_play_type';
